import * as React from "react";
import Box from "@mui/material/Box";
import SpeedDial from "@mui/material/SpeedDial";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import PolylineIcon from "@mui/icons-material/Polyline";
import SaveIcon from "@mui/icons-material/Save";
import PrintIcon from "@mui/icons-material/Print";
import HighlightAltIcon from "@mui/icons-material/HighlightAlt";
import ViewListIcon from "@mui/icons-material/ViewList";

const actions = [
  { icon: <PolylineIcon />, name: "Draw" },
  { icon: <HighlightAltIcon />, name: "Select" },
  { icon: <ViewListIcon />, name: "Show Data" },
  { icon: <SaveIcon />, name: "Save" },
  { icon: <PrintIcon />, name: "Print" },
];

export default function DesignToolBox() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <SpeedDial
      ariaLabel="Design Toolbox Pallett"
      sx={{ position: "relative", bottom: -500, right: 0.25 }}
      icon={<BuildCircleIcon />}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
    >
      {actions.map((action) => (
        <SpeedDialAction
          key={action.name}
          icon={action.icon}
          tooltipTitle={action.name}
          onClick={handleClose}
          sx={{ zIndex: 100 }}
        />
      ))}
    </SpeedDial>
  );
}
